import { register } from "async-ops";
import { callMvcApi } from "../../../call-web-api";
import { getDefaultOptions } from "../../../utils/fetch";

export const KEY_INFORMATION_CASE_SEARCH = "KEY_INFORMATION_CASE_SEARCH";

export const service = async (data) => {
  const options: object = {
    url: `/Api/EaCaseSearchApiController/ExecuteKeyInformationCaseSearch`,
    method: "POST",
    body: JSON.stringify(data),
    ...getDefaultOptions(),
  };

  const response = callMvcApi(options);
  return response;
};


const mockData = () => {
  return ([])
};

const mock = () => Promise.resolve(mockData());

register(KEY_INFORMATION_CASE_SEARCH, service, mock);
